import type { SxProps } from '@mui/material';
import { FONT_ORACLE, PAGE_MAX_WIDTH, TEXT_PRIMARY } from 'components/pages/insights/constants';

export const containerSx: SxProps = {
  maxWidth: PAGE_MAX_WIDTH,
  mx: 'auto',
  py: 5,
};

export const backButtonSx: SxProps = {
  display: { xs: 'none', md: 'flex' },
  alignItems: 'center',
  gap: 1,
  fontFamily: FONT_ORACLE,
  fontWeight: 500,
  fontSize: 16,
  color: TEXT_PRIMARY,
  p: 1,
  borderRadius: '40px',
  mb: 1,
};

export const mobileBackButtonSx: SxProps = {
  display: { xs: 'flex', md: 'none' },
  alignItems: 'center',
  justifyContent: 'center',
  width: 36,
  height: 36,
  borderRadius: '50%',
  bgcolor: '#F7F7F7',
  mb: 2,
  mx: 5,
};

export const introSx: SxProps = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: { xs: 'flex-start', md: 'center' },
  gap: { xs: 1.5, md: 2 },
  textAlign: { xs: 'left', md: 'center' },
  mb: 6,
};

export const titleSx: SxProps = {
  fontFamily: FONT_ORACLE,
  fontWeight: 400,
  fontSize: { xs: 26, md: 40 },
  color: TEXT_PRIMARY,
  letterSpacing: { xs: '-1.04px', md: '-1.6px' },
  lineHeight: { xs: 'normal', md: 1.2 },
  mx: { xs: 'auto', lg: 0 },
};

export const gridContainerSx: SxProps = {
  display: { xs: 'none', md: 'flex' },
  flexWrap: 'wrap',
  columnGap: 3,
  rowGap: 4,
  justifyContent: 'center',
  '@media (min-width: 1024px)': {
    justifyContent: 'flex-start',
  },
};

export const cardWrapperSx: SxProps = {
  width: 'calc(33.333% - 16px)',
  '@media (min-width: 1024px)': {
    width: 'calc(25% - 18px)',
  },
};

export const masonryContainerSx: SxProps = {
  display: { xs: 'flex', md: 'none' },
  gap: 4,
  px: 5,
};

export const masonryColumnSx: SxProps = {
  display: 'flex',
  flexDirection: 'column',
  gap: 4,
  flex: 1,
  minWidth: 0,
};
